import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInterceptor";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CodeEditor from "../component/CodeEditor";

const EmailSetting = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
    host: "",
    port: "",
    fromEmail: "",
    bccEmail: "",
    ccEmail: "",
    fromEmail1: "",
    bccEmail1: "",
    ccEmail1: "",
    careerTemplate: "",
    enquiryTemplate: "",
    enquirySubject: "",
    careerSubject: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
    host: "",
    port: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `emailSettings/getEmailSettings`
      );
      const { data } = response?.data;
      setData({ ...data });
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again!"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    // Validation for required fields
    let hasErrors = false;
    const newErrors = {};

    if (!data.email) {
      newErrors.email = "Email is required";
      hasErrors = true;
    }
    if (!data.password) {
      newErrors.password = "Password is required";
      hasErrors = true;
    }
    if (!data.host) {
      newErrors.host = "Host is required";
      hasErrors = true;
    }
    if (!data.port) {
      newErrors.port = "Port is required";
      hasErrors = true;
    }

    setErrors(newErrors);

    if (hasErrors) return;

    const newData = { ...data };
    if (newData?._id) {
      delete newData?._id;
      delete newData?.createdAt;
      delete newData?.updatedAt;
      delete newData?.__v;
    }
    try {
      const response = await axiosInstance.post(
        `emailSettings/updateEmailSettings`,
        newData
      );
      if (response?.status === 200) {
        toast.success(response?.data?.message);
        fetchData();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again!"
      );
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="content-wrapper pd-top">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">Email Configuration</h3>
      </div>
      <div className="col-md-12 grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleUpdate}>
                <div className="page-header mb-2">
                  <h2 className="page-title">Sender </h2>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="email"
                        name="email"
                        placeholder="Enter email"
                        value={data?.email}
                        onChange={handleChange}
                      />
                      {errors?.email && (
                        <p className="text-danger">{errors?.email}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="password" className="col-form-label">
                        App Password
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control form-control-sm"
                          id="password"
                          name="password"
                          placeholder="Enter password"
                          value={data?.password}
                          onChange={handleChange}
                        />
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? (
                              <FaEye className="fs-5" />
                            ) : (
                              <FaEyeSlash className="fs-5" />
                            )}
                          </span>
                        </div>
                      </div>
                      {errors?.password && (
                        <p className="text-danger">{errors?.password}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        SMTP Host
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="host"
                        name="host"
                        placeholder="Enter host"
                        value={data?.host}
                        onChange={handleChange}
                      />
                      {errors?.host && (
                        <p className="text-danger">{errors?.host}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Port
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="port"
                        name="port"
                        placeholder="Enter port"
                        value={data?.port}
                        onChange={handleChange}
                      />
                      {errors?.port && (
                        <p className="text-danger">{errors?.port}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="page-header mt-4 mb-2">
                  <h2 className="page-title">Enquiries Receiver</h2>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="fromEmail"
                        name="fromEmail"
                        placeholder="Enter a email"
                        value={data?.fromEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        BCC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="bccEmail"
                        name="bccEmail"
                        placeholder="Enter bcc email"
                        value={data?.bccEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        CC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="ccEmail"
                        name="ccEmail"
                        placeholder="Enter cc email"
                        value={data?.ccEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Subject
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="enquirySubject"
                        name="enquirySubject"
                        placeholder="Enter a Subject"
                        value={data?.enquirySubject}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Mail Template
                      </label>
                      <CodeEditor
                        value={data.enquiryTemplate}
                        style={{ height: "400px" }}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "enquiryTemplate", value },
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="page-header mt-4 mb-2">
                  <h2 className="page-title">Careers Receiver </h2>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="fromEmail1"
                        name="fromEmail1"
                        placeholder="Enter a email"
                        value={data?.fromEmail1}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        BCC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="bccEmail1"
                        name="bccEmail1"
                        placeholder="Enter bcc email"
                        value={data?.bccEmail1}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        CC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="ccEmail1"
                        name="ccEmail1"
                        placeholder="Enter cc email"
                        value={data?.ccEmail1}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Subject
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="careerSubject"
                        name="careerSubject"
                        placeholder="Enter a Subject"
                        value={data?.careerSubject}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label"
                      >
                        Mail Template
                      </label>
                      <CodeEditor
                        value={data.careerTemplate}
                        style={{ height: "400px" }}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "careerTemplate", value },
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="text-start mt-4">
                  <Link to="/dashboard">
                    <button className="btn btn-secondary mr-2">Back</button>
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2 mx-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailSetting;
